export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4669.8f85edf1.jpg";